import { render, staticRenderFns } from "./app-carousel-item.vue?vue&type=template&id=a172d0c2&"
import script from "./app-carousel-item.vue?vue&type=script&lang=js&"
export * from "./app-carousel-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports